

@if ((fetchingResults$ | async)!) {
  <p style="text-align:center">
    <mat-spinner style="margin:0 auto;"  [diameter]="40"></mat-spinner>
  </p>
}

@if (!(fetchingResults$ | async)!) {
  <div class="car-details">
    <div class="fil-ariane">
      <!--
      <button mat-button matTooltipPosition="above" matTooltip="Share" (click)="goToPreviousPage()" class="simple-button-{{businessLine?.toLowerCase()}}">
        <mat-icon>keyboard_return</mat-icon>
        Retour
      </button>  -->
      <span class="clickable-text" (click)="goToPreviousPage()" > < Retour aux résultats</span> > {{car.make}} {{car.model}} {{car.version}}
    </div>
    <div class="car-main-block">
      <div class="car-image">
        <div class="car-image-main">
          @if (carImagesFolder?.length! < 1 && car.imagesFilenames?.length! > 0) {
            <p class="spinner">
              <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
            </p>
          }
          <img [src]="(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.png'" alt="Car Image"
            (click)="nextImage()">
            <div class = "img-arrow-container">
              <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="prevImage();$event.stopPropagation()" class="pic-arrow-left"><mat-icon>arrow_back_ios</mat-icon></button>
              <button [disabled]="!(carImagesFolder != undefined && carImagesFolder!.length > 1)" mat-button (click)="nextImage();$event.stopPropagation()" class="pic-arrow-right"><mat-icon>arrow_forward_ios</mat-icon></button>
            </div>
            @if ((carImagesFolder != undefined && carImagesFolder!.length > 0)) {
              <div class = "img-counter">
                {{ currentImageIndex + 1 }}/{{ carImagesFolder!.length }}
              </div>
            }
          </div>
          <div class="car-image-thumbs">
            @for (file of (carImagesFolder$ | async)  ; track file; let i = $index) {
              <div class="image-thumb"
                [style.border-color]=" (i===currentImageIndex) ? 'lightgray': 'white'">
                <!-- <p class="spinner" *ngIf="carImagesFolder?.length! < 1 && car.imagesFilenames?.length! > 0">
                <mat-spinner style="margin:0 auto;"  [diameter]="35"></mat-spinner>
              </p>  -->
              <!-- <img mat-card-image [src]= "(currentImage != undefined) ? currentImage : 'assets/images/car_image_holder.png'" alt="Car Image">
              -->
              <!-- <img src= "assets/images/car_image_holder.png" alt="Car Image"> -->
              <img mat-card-image
                [src]="((carImagesFolder$ | async)?.length! > 0) ? getCarImage(i) : 'assets/images/car_image_holder.png'" alt="Car Image"
                (click)="selectImage(i)"
                >
              </div>
            }
          </div>
          <div class="seller-details">
            <!-- <div class="seller-details">Postée le {{dateFormat(car.created)}}</div> -->
            <h6> {{businessLine== CarBusinessLine.BUY ? 'Vendu' : 'Loué'}} par
              <button mat-button matTooltipPosition="above" matTooltip="View dealer details"
                (click)="goToSellerPage(car.providerId);$event.stopPropagation()"
                class="simple-button">
                <mat-icon>{{(car.providerType==DealerType.PROFESSIONAL) ? 'domain' : 'person'}} </mat-icon>
                @if (car.providerType==DealerType.PROFESSIONAL) {
                  <span>
                    {{ car.providerBusinessName }}
                  </span>
                }
                @if (car.providerType!=DealerType.PROFESSIONAL) {
                  <span>
                    {{ car.providerName }}
                  </span>
                }
              </button>
              <br />
              <span>
                <label>Avis clients: </label>
                @for (r of car.providerRatingsSummary.indicators; track r; let i = $index) {
                  <span>
                    <!--{{currentProvider.ratingsCounts[i]}}
                    <mat-icon *ngIf="r===1">star</mat-icon>
                    <mat-icon *ngIf="r!==1"> {{r===0?'star_outlined':'star_half'}}</mat-icon> -->
                    @if (r===1) {
                      <mat-icon class="seller-icon">star</mat-icon>
                    }
                    @if (r!==1) {
                      <mat-icon class="seller-icon"> {{r===0?'star_outlined':'star_half'}}</mat-icon>
                    }
                  </span>
                }
                <b>{{ car.providerRatingsSummary.average.toFixed(2)}} </b>
                <mat-icon class="seller-icon" (click)="showDetails = !showDetails; ;$event.stopPropagation()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">info</mat-icon>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="trigger"
                  [cdkConnectedOverlayOpen]="showDetails">
                  <div class="ratings-details">
                    <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon>({{car.providerRatingsSummary.counts[4]}})</h6>
                    <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon>({{car.providerRatingsSummary.counts[3]}})</h6>
                    <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{car.providerRatingsSummary.counts[2]}})</h6>
                    <h6><mat-icon>star</mat-icon><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{car.providerRatingsSummary.counts[1]}})</h6>
                    <h6><mat-icon>star</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon><mat-icon>star_outlined</mat-icon>({{car.providerRatingsSummary.counts[0]}})</h6>
                  </div>
                </ng-template>
                ({{ getSellerRatingsTotalCount()}} avis)
              </span>
            </h6>
          </div>
        </div>
        <div class="car-data-section">
          <div class="car-make-model">
            <div class="car-make-model-year">
              <h3> {{car.make}} {{car.model}} {{car.version}}</h3>
              <h4> {{car.year}} </h4>
            </div>
            <div class="buyer-actions">
              @if (!isSeller) {
                <button mat-button class="simple-button-{{businessLine?.toLowerCase()}}" matTooltipPosition="above" matTooltip="Favorite" (click)="toggleFavorite();$event.stopPropagation()"><mat-icon>{{car.favorite? "favorite": "favorite_outline"}} </mat-icon></button>
              }
              <button mat-button class="simple-button-{{businessLine?.toLowerCase()}}" matTooltipPosition="above" matTooltip="Share"><mat-icon>share</mat-icon></button>
            </div>
          </div>
          <!-- <div class="car-version"> </div> -->
          <h6> @for (ft of car.features; track ft; let i = $index) {
            <span> @if (i>0) {
              <span>,</span>
            } {{ft}}  </span>
          }</h6>
          <h6>{{car.offerTitle}} - {{car.offerDescription}}</h6>
          <div class="car-location">
            <!-- <mat-icon>location_on</mat-icon> -->
            <!-- {{ car.city }}, {{ getCountryName(car.country) }} -->
            <img class="mini-flag" src="assets/images/country-flags/{{car.country}}.png" alt="{{car.country}}">
            &nbsp; {{ car.city }}
          </div >
          <div class="car-price-location">
            @if (car != undefined) {
              <h3 class="car-price">
                {{ moneyFormat(""+$safeNavigationMigration(car!.getCarPrice!(businessLine!)?.amount)) }}
                <span class="price-currency">
                  {{ car!.getCarPrice!(businessLine!)?.currency }}
                  @if (businessLine==CarBusinessLine.RENT) {
                    <span>
                      /J
                    </span>
                  }
                </span>
              </h3>
            }
          </div>
          <mat-divider></mat-divider>
          <div class="car-key-details">
            <h5><mat-icon>mail</mat-icon><span class="label-text">Année: </span>{{car.year}}</h5>
            <h5><mat-icon>mail</mat-icon><span class="label-text">Compteur: </span>{{car.mileage}} km</h5>
            <h5><mat-icon>mail</mat-icon><span class="label-text">Boite: </span>{{car.gearBox }}</h5>
            <h5><mat-icon>mail</mat-icon><span class="label-text">Carburant: </span>{{car.fuel}}</h5>
          </div>
          <mat-divider></mat-divider>
          <div class="dealer-actions">
            @if (!isSeller) {
              <div class="button-section">
                <!-- <button type="submit" mat-button class="cta-button"> <mat-icon>phone_enabled</mat-icon> Contacter Vendeur </button> -->
                <button  type="submit" mat-button class="cta-button-{{businessLine?.toLowerCase()}}"
                  (click)="goToProposalOrBooking()">
                  <!-- <span *ngIf="(fetchingPreview$ | async)" style="text-align:center">
                  <mat-spinner  [diameter]="20"></mat-spinner>
                </span>
                <span *ngIf="!(fetchingPreview$ | async)">
                  {{ (previewTotalCount$ | async) }} résultats
                </span> -->
                <mat-icon>attach_money</mat-icon> {{ businessLine==CarBusinessLine.BUY ? 'Faire une Offre' : 'Réserver'}}
              </button>
              <!-- <button *ngIf="car.favorite" mat-button class="cta-button-{{businessLine?.toLowerCase()}}"> <mat-icon>share</mat-icon>Partager</button> -->
              <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}" matTooltipPosition="above" matTooltip="Email Seller" (click)="openMessageDialog()" >
                <mat-icon>mail</mat-icon> Contacter Vendeur
              </button>
              <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}" (click)="goToCustomerPage()">
                <mat-icon>favorite</mat-icon>Gérer
              </button>
            </div>
          }
          @if (isSeller) {
            <div class="button-section">
              <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}"> <mat-icon>share</mat-icon>Partager </button>
              <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}" [routerLink]="['/sell/offer']" fragment="{{car.carId}}">
                <mat-icon>edit</mat-icon>Editer
              </button>
            </div>
          }
        </div>
      </div>
      <!--
      <div class="main-section">
        <div class="car-image">
          <div *ngIf="isSeller" class="edit-section">
            <label for="files" class="btn"> Ajouter une photo ... </label>
            <input id="files" type="file" accept="image/*" multiple (change)="uploadImage(car.carId, $event)" />
            <div class="seller-actions">
              <button mat-button matTooltipPosition="above" matTooltip="View car details" (click)="goToCarDetailsPage(car.carId);$event.stopPropagation()"><mat-icon>open_in_new</mat-icon></button>
              <button *ngIf="isSeller" mat-button matTooltipPosition="above" matTooltip="Edit car details" (click)="goToCarEditPage(car.carId)" ><mat-icon>edit</mat-icon></button>
              <button class="simple-button" mat-button matTooltipPosition="above" matTooltip="Update car details" (click)="openCarEditDialog();$event.stopPropagation()" >Mettre a jour les details<mat-icon>edit</mat-icon></button>
              <button class="simple-button"  mat-button matTooltipPosition="above" matTooltip="Share"><mat-icon>share</mat-icon>Partager le lien</button>
              <button class="simple-button"  mat-button (click)="openPriceDialog(car.carId) ;$event.stopPropagation()">Changer le Prix<mat-icon>attach_money</mat-icon></button>
            </div>
          </div>
        </div>
      </div>
      -->
    </div>
    <div class="car-details-block">
      <div class="car-details-block-titles">
        <!-- <button mat-button class="simple-button-{{businessLine?.toLowerCase()}}">VOTRE VENDEUR</button>
        <button mat-button class="simple-button-{{businessLine?.toLowerCase()}}">PLUS DE DETAILS SUR LA VOITURE</button> -->
        <h4 (click)="sectionId='seller'"
          [style.color]=" (sectionId==='seller') ? 'steelblue': 'black'"
          [style.border-bottom-color]=" (sectionId==='seller') ? 'steelblue': 'white'"
          >
          VOTRE VENDEUR
        </h4>
        <h4 (click)="sectionId='car'"
          [style.color]=" (sectionId==='car') ? 'steelblue': 'black'"
          [style.border-bottom-color]=" (sectionId==='car') ? 'steelblue': 'white'"
          >
          PLUS DE DETAILS SUR LA VOITURE
        </h4>
      </div>
      <mat-divider></mat-divider>
      @if (sectionId=='seller') {
        <div class="seller-block">
          <div class="seller-block-profile">
            <div>
              <img class="seller-pic"
                [src]="(currentDealerImage != undefined) ? currentDealerImage : 'assets/images/autodeal_logo.png'" alt="Car Image"
                (click)="nextImage()">
              </div>
              <div>
                <h4>{{ car.providerName }} - {{ car.providerBusinessName }}</h4>
                <h6><mat-icon>location_on</mat-icon> {{ car.city }} - {{ car.providerCountry }} </h6>
                <div class="button-section">
                  <button mat-button class="cta-button-{{businessLine?.toLowerCase()}}" (click)="openAppointmentDialog();$event.stopPropagation()">
                    <mat-icon>calendar_month</mat-icon>Prendre rendez-vous
                  </button>
                </div>
              </div>
              <div>
                <h5>Voitures en vente: {{  (sameSellerCarBriefs$ | async)!.length }} </h5>
              </div>
            </div>
            <div class="seller-block-ratings">
              <div>
                <h4>Avis</h4>
                <h6>Description et autres</h6>
                <h3><mat-icon class="mat-icon-{{businessLine?.toLowerCase()}}">star</mat-icon> <span [style.font-size]="'40px'"> {{ car.providerRatingsSummary.average.toFixed(2)}} </span> / 5.0</h3>
                <h6 class="ratings-recommended">
                  <b>Recommendé</b> <br />
                  {{100 * (car.providerRatingsSummary.counts[4] +car.providerRatingsSummary.counts[3]) / getSellerRatingsTotalCount()}} %
                  de commentaires recommandés (note de 4 ou 5/5)
                </h6>
              </div>
              <div>
                @for (i of [5,4,3,2,1]; track i) {
                  <div class="rating-details">
                    <h5>{{i}},0 </h5><mat-icon class="mat-icon-{{businessLine?.toLowerCase()}}">star</mat-icon>
                    <mat-progress-bar mode="determinate" value="{{100 * car.providerRatingsSummary.counts[i-1] / getSellerRatingsTotalCount()}}"></mat-progress-bar>
                    {{car.providerRatingsSummary.counts[i-1]}}
                  </div>
                }
              </div>
            </div>
          </div>
        }
        @if (sectionId=='car') {
          <div class="car-block">
            <div class="car-block-main">
              <div >
                <h3>Origine</h3>
                <h6><b>Pays d'origine:</b> {{car.countryOrigin}}</h6>
                <h6><b>Pays de localisation:</b> {{car.country}}</h6>
                <h6><b>Ville:</b> {{car.city}}</h6>
                <h6><b>Date d'arrivée:</b> {{car.arrivalDate}}</h6>
                <h6><b>Lieu d'arrivée:</b> {{car.arrivalLocation}}</h6>
                <h6><b>Historique:</b> {{car.serviceHistory}}</h6>
                <h6><b>Date création:</b> {{dateFormat(car.created)}}</h6>
                <h6><b>Dernière mis à jour:</b> {{dateFormat(car.lastUpdated)}}</h6>
                <h6><b>Statut:</b> {{car.status}}</h6>
              </div>
              <div>
                <h3>Spécifications</h3>
                <h6><b>Année:</b> {{car.year}}</h6>
                <h6><b>Carosserie:</b> {{car.bodyType}}</h6>
                <h6><b>Kilométrage:</b> {{car.mileage}} km</h6>
                <h6><b>Carburant:</b> {{car.fuel}}</h6>
                <h6><b>Puissance:</b> {{car.powerHp}}</h6>
                <h6><b>Boite:</b> {{car.gearBox}}</h6>
                <h6><b>Portières:</b> {{car.doors}}</h6>
                <h6><b>Sièges:</b> {{car.seats}}</h6>
                <h6><b>Couleur extérieure:</b> {{car.exteriorColor}}</h6>
                <h6><b>Description:</b> {{car.description}}</h6>
              </div>
            </div>
            <mat-accordion>
              <mat-expansion-panel expanded>
                <mat-expansion-panel-header>
                  <mat-panel-title> <h3>Autres détails</h3> </mat-panel-title>
                  <mat-panel-description>
                    <!-- Currently I am {{panelOpenState() ? 'open' : 'closed'}} -->
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <h6><b>Couleur métalisée:</b> {{car.exteriorColorMetallic}}</h6>
                <h6><b>Couleur intérieure:</b> {{car.interiorColor}}</h6>
                <h6><b>Matériel intérieur:</b> {{car.interiorMaterial}}</h6>
                <h6><b>Equipements optionnels:</b> {{car.optionalEquipment}}</h6>
                <h6><b>Equipement extra:</b> {{car.extraEquipment}}</h6>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        }
      </div>
      <div class="similar-cars">
        <h3>Véhicules similaires ({{  (similarCarBriefs$ | async)!.length }})</h3>
        <app-car-box-list
          [businessLine]= businessLine!
          [carBriefs]="similarCarBriefs" >
          <!-- [favorites]="(currentUserFavorites$ | async)!"
          [carImageDatas]="(carImagesFolder != undefined)?carImagesFolder![0]:defaultImageDatas"> -->
        </app-car-box-list>
      </div>
      <div class="same-seller-cars">
        <h3>Véhicules du meme vendeur ({{  (sameSellerCarBriefs$ | async)!.length }})</h3>
        <app-car-box-list
          [businessLine]= businessLine!
          [carBriefs]="sameSellerCarBriefs" >
          <!-- [favorites]="(currentUserFavorites$ | async)!"
          [carImageDatas]="(carImagesFolder != undefined)?carImagesFolder![0]:defaultImageDatas"> -->
        </app-car-box-list>
      </div>
    </div>
  }




